import { api } from './api';

export interface CreateSubscriptionCodesRequest {
  prefix: string;
  productId: string;
  months: number;
  count: number;
}

export interface SubscriptionCodeItem {
  code: string;
  months: number;
  used: boolean;
  productId?: string;
  createdAt?: string;
}

export const createSubscriptionCodes = async (request: CreateSubscriptionCodesRequest) => {
  // Backend returns 201 Created on success
  return await api.post('/subscription-code', request, {});
};

export const fetchSubscriptionCodes = async (): Promise<SubscriptionCodeItem[]> => {
  const response = await api.get('/subscription-code');
  return response.data as SubscriptionCodeItem[];
};

export const fetchSubscriptionCodesByProductId = async (productId: string): Promise<SubscriptionCodeItem[]> => {
  const all = await fetchSubscriptionCodes();
  return all.filter((c) => c.productId === productId);
};
